import { today, addMonths, addYears } from '../lib/date.js';
import { findElementInEventPath } from '../lib/event.js';
import { goToPrevOrNext, switchView } from './functions.js';

function goToSelectedMonthOrYear(datepicker, selection) {
  var picker = datepicker.picker;
  var viewDate = new Date(picker.viewDate);
  var viewId = picker.currentView.id;
  var newDate = viewId === 1 ? addMonths(viewDate, selection - viewDate.getMonth()) : addYears(viewDate, selection - viewDate.getFullYear());
  picker.changeFocus(newDate).changeView(viewId - 1).render();
}

export function onClickTodayBtn(datepicker) {
  var picker = datepicker.picker;
  var currentDate = today();

  if (datepicker.config.todayBtnMode === 1) {
    if (datepicker.config.autohide) {
      datepicker.setDate(currentDate);
      return;
    }

    datepicker.setDate(currentDate, {
      render: false
    });
    picker.update();
  }

  if (picker.viewDate !== currentDate) {
    picker.changeFocus(currentDate);
  }

  picker.changeView(0).render();
}
export function onClickClearBtn(datepicker) {
  datepicker.setDate({
    clear: true
  });
}
export function onClickViewSwitch(datepicker) {
  switchView(datepicker);
}
export function onClickPrevBtn(datepicker) {
  goToPrevOrNext(datepicker, -1);
}
export function onClickNextBtn(datepicker) {
  goToPrevOrNext(datepicker, 1);
} // For the picker's main block to delegete the events from `datepicker-cell`s

export function onClickView(datepicker, ev) {
  var target = findElementInEventPath(ev, '.datepicker-cell');

  if (!target || target.classList.contains('disabled')) {
    return;
  }

  var _datepicker$picker$cu = datepicker.picker.currentView,
      id = _datepicker$picker$cu.id,
      isMinView = _datepicker$picker$cu.isMinView;

  if (isMinView) {
    datepicker.setDate(Number(target.dataset.date));
  } else if (id === 1) {
    goToSelectedMonthOrYear(datepicker, Number(target.dataset.month));
  } else {
    goToSelectedMonthOrYear(datepicker, Number(target.dataset.year));
  }
}
export function onMousedownPicker(ev) {
  ev.preventDefault();
}